"use strict";
// NOTE: the functions of this file have proper error logging in a file.
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchHistoricalPricesFromCoinGecko = fetchHistoricalPricesFromCoinGecko;
exports.putPricesDataToHistoricalPricesDynamoDb = putPricesDataToHistoricalPricesDynamoDb;
exports.getPricesDataFromHistoricalPricesDynamoDb = getPricesDataFromHistoricalPricesDynamoDb;
exports.getLatestDateFromHistoricalPricesDynamoDb = getLatestDateFromHistoricalPricesDynamoDb;
exports.updateHistoricalPricesDynamoDb = updateHistoricalPricesDynamoDb;
exports.massageHistoricalPrices = massageHistoricalPrices;
exports.getHistoricalStSuiPrice = getHistoricalStSuiPrice;
const constants_js_1 = require("../../pyth/constants.js");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
const dailyRevenue_js_1 = require("./dailyRevenue.js");
const decimal_js_1 = require("decimal.js");
const dynamoDBClient_js_1 = require("../../dynamoDBClient.js");
const logger_js_1 = require("../../logger.js");
const TVL_js_1 = require("./TVL.js");
// TODO: the code for optional table and client is not required in production, seperate out the ddbClient to  a different function and tableName in env only
// Fetch the historical price for given coins and number of days
// Must give coins to fetch prices for
async function fetchHistoricalPricesFromCoinGecko(params) {
    const coinGeckoApiKey = params.coinGeckoApiKey;
    const coinsToFetch = params.coinsToFetch;
    const historicalPrices = {};
    const errors = [];
    const promises = coinsToFetch.map(async (o) => {
        const id = constants_js_1.coinGeckoPriceFeed[o.coinPair].coinId;
        const options = {
            method: "GET",
            headers: {
                accept: "application/json",
                "x-cg-pro-api-key": coinGeckoApiKey,
            },
        };
        try {
            const req_url = `https://pro-api.coingecko.com/api/v3/coins/${id}/market_chart?vs_currency=usd&days=${o.days}&interval=daily&precision=10`;
            const res = await fetch(req_url, options);
            if (!res.ok) {
                throw new Error(`HTTP error in fetchPricesFromCoinGecko! status: ${res.status}`);
            }
            const resJson = (await res.json());
            if (!resJson)
                throw new Error(`Historical Gecko not found for id: ${id}`);
            historicalPrices[o.coinPair] = resJson.prices;
        }
        catch (error) {
            const errorObj = error instanceof Error ? error : new Error(String(error));
            (0, logger_js_1.logError)(`Failed to fetch historical prices for coin ${o.coinPair}`, {
                component: "prices",
                operation: "fetchHistoricalPricesFromCoinGecko",
                context: { coinPair: o.coinPair, coinId: id, days: o.days },
                error: errorObj,
            });
            errors.push({ coinPair: o.coinPair, error: errorObj });
        }
    });
    await Promise.all(promises);
    if (errors.length > 0) {
        const failedCoins = errors.map((e) => e.coinPair).join(", ");
        const errorMessage = `Failed to fetch historical prices for ${errors.length} coin(s): ${failedCoins}`;
        throw new Error(errorMessage);
    }
    return historicalPrices;
}
// Puts data to dynammoDB
async function putPricesDataToHistoricalPricesDynamoDb(params) {
    const HISTORICAL_PRICES_TABLE_NAME = process.env.HISTORICAL_PRICES_TABLE_NAME;
    const tableName = params.tableName
        ? params.tableName
        : HISTORICAL_PRICES_TABLE_NAME;
    if (!tableName)
        throw new Error("Historical Prices Table not found");
    const ddbClient = (0, dynamoDBClient_js_1.getDynamoDBClient)();
    const ddbDocClient = (0, dynamoDBClient_js_1.getDynamoDBDocClient)(ddbClient);
    const historicalPrices = params.historicalPrices;
    const items = [];
    for (const coinPair in historicalPrices) {
        for (const timePrice of historicalPrices[coinPair]) {
            items.push({
                coinPair: coinPair,
                time: timePrice[0],
                price: timePrice[1],
            });
        }
    }
    while (items.length > 0) {
        const batch = items.splice(0, 25);
        const writeRequests = batch.map((item) => {
            return {
                PutRequest: {
                    Item: item,
                },
            };
        });
        const params = {
            RequestItems: {
                [tableName]: writeRequests,
            },
        };
        try {
            let unprocessedItems = undefined;
            do {
                const response = await ddbDocClient.send(new lib_dynamodb_1.BatchWriteCommand(params));
                unprocessedItems = response.UnprocessedItems;
                if (unprocessedItems && Object.keys(unprocessedItems).length > 0) {
                    (0, logger_js_1.logInfo)("Retrying unprocessed items in batch write", {
                        component: "prices",
                        operation: "putPricesDataToHistoricalPricesDynamoDb",
                        context: {
                            unprocessedItemsCount: Object.keys(unprocessedItems).length,
                        },
                    });
                    params.RequestItems = unprocessedItems;
                }
            } while (unprocessedItems && Object.keys(unprocessedItems).length > 0);
        }
        catch (err) {
            const errorObj = err instanceof Error ? err : new Error(String(err));
            (0, logger_js_1.logError)(`BatchWriteCommand failed during historical prices data insertion`, {
                component: "prices",
                operation: "putPricesDataToHistoricalPricesDynamoDb",
                context: {
                    tableName: tableName,
                    batchSize: batch.length,
                    totalItemsRemaining: items.length,
                },
                error: errorObj,
            });
            throw errorObj;
        }
    }
}
// gets the coin's price for given dates
// coinPair is in coin/usd
async function getPricesDataFromHistoricalPricesDynamoDb(params) {
    const HISTORICAL_PRICES_TABLE_NAME = process.env.HISTORICAL_PRICES_TABLE_NAME;
    const tableName = params.tableName
        ? params.tableName
        : HISTORICAL_PRICES_TABLE_NAME;
    const ddbClient = (0, dynamoDBClient_js_1.getDynamoDBClient)();
    const ddbDocClient = (0, dynamoDBClient_js_1.getDynamoDBDocClient)(ddbClient);
    const commands = params.priceQuery.map((q) => {
        const command = new client_dynamodb_1.QueryCommand({
            TableName: tableName,
            KeyConditionExpression: "coinPair = :coinPair AND #time BETWEEN :start AND :end",
            ExpressionAttributeNames: { "#time": "time" },
            ExpressionAttributeValues: {
                ":coinPair": { S: q.coinPair },
                ":start": { N: q.minTime.toString() },
                ":end": { N: q.maxTime.toString() },
            },
        });
        return command;
    });
    try {
        const result = {};
        for (const command of commands) {
            const response = await ddbDocClient.send(command);
            if (response.Items) {
                const items = response.Items;
                items.forEach((item) => {
                    if (!result[item.coinPair.S])
                        result[item.coinPair.S] = [];
                    result[item.coinPair.S].push([
                        Number(item.time.N),
                        Number(item.price.N),
                    ]);
                });
            }
        }
        return result;
    }
    catch (err) {
        const errorObj = err instanceof Error ? err : new Error(String(err));
        (0, logger_js_1.logError)(`QueryCommand failed during historical prices data retrieval`, {
            component: "prices",
            operation: "getPricesDataFromHistoricalPricesDynamoDb",
            context: {
                tableName: tableName,
                priceQuery: params.priceQuery,
            },
            error: errorObj,
        });
        throw errorObj;
    }
}
async function getLatestDateFromHistoricalPricesDynamoDb(params) {
    const HISTORICAL_PRICES_TABLE_NAME = process.env.HISTORICAL_PRICES_TABLE_NAME;
    const tableName = params.tableName
        ? params.tableName
        : HISTORICAL_PRICES_TABLE_NAME;
    const ddbClient = (0, dynamoDBClient_js_1.getDynamoDBClient)();
    const ddbDocClient = (0, dynamoDBClient_js_1.getDynamoDBDocClient)(ddbClient);
    const commands = params.coinPairs.map((coinPair) => {
        const command = new client_dynamodb_1.QueryCommand({
            TableName: tableName,
            KeyConditionExpression: "coinPair = :coin",
            ExpressionAttributeValues: {
                ":coin": { S: coinPair },
            },
            ScanIndexForward: false,
            Limit: 1,
        });
        return command;
    });
    try {
        const result = {};
        const promises = commands.map(async (command) => {
            const response = await ddbDocClient.send(command);
            if (response.Items) {
                const items = response.Items;
                result[items[0].coinPair.S] = Number(items[0].time.N);
            }
        });
        await Promise.all(promises);
        return result;
    }
    catch (err) {
        const errorObj = err instanceof Error ? err : new Error(String(err));
        (0, logger_js_1.logError)(`QueryCommand failed during latest date retrieval`, {
            component: "prices",
            operation: "getLatestDateFromHistoricalPricesDynamoDb",
            context: {
                tableName: tableName,
                coinPairs: params.coinPairs,
            },
            error: errorObj,
        });
        throw errorObj;
    }
}
async function updateHistoricalPricesDynamoDb(params) {
    try {
        const HISTORICAL_PRICES_TABLE_NAME = process.env.HISTORICAL_PRICES_TABLE_NAME;
        const tableName = params.tableName
            ? params.tableName
            : HISTORICAL_PRICES_TABLE_NAME;
        const ddbClient = (0, dynamoDBClient_js_1.getDynamoDBClient)();
        const ddbDocClient = (0, dynamoDBClient_js_1.getDynamoDBDocClient)(ddbClient);
        if (!tableName)
            throw new Error("Historical Prices Table not found");
        const existingCoinPairs = [];
        const newCoinPairs = [];
        for (const key of params.coinPairs) {
            const command = new client_dynamodb_1.QueryCommand({
                TableName: tableName,
                KeyConditionExpression: `coinPair = :key`,
                ExpressionAttributeValues: {
                    ":key": { S: key },
                },
                Limit: 1, // Stop after finding the first match
            });
            try {
                const response = await ddbDocClient.send(command);
                if (response.Items?.length && response.Items.length > 0) {
                    existingCoinPairs.push(key);
                }
                else {
                    newCoinPairs.push(key);
                }
            }
            catch (error) {
                const errorObj = error instanceof Error ? error : new Error(String(error));
                (0, logger_js_1.logError)(`Failed to query existing coin pair in DynamoDB`, {
                    component: "prices",
                    operation: "updateHistoricalPricesDynamoDb",
                    context: { coinPair: key, tableName },
                    error: errorObj,
                });
                throw errorObj;
            }
        }
        const lastUpdatedTimes = await getLatestDateFromHistoricalPricesDynamoDb({
            tableName,
            coinPairs: existingCoinPairs,
        });
        const coinsToFetch = Object.entries(lastUpdatedTimes)
            .map((o) => {
            return {
                coinPair: o[0],
                days: Math.floor((Date.now() - o[1]) / (24 * 60 * 60 * 1000)) !== 0
                    ? Math.floor((Date.now() - o[1]) / (24 * 60 * 60 * 1000))
                    : 1,
            };
        })
            .concat(newCoinPairs.map((coinPair) => {
            return {
                coinPair,
                days: ((0, dailyRevenue_js_1.getEndOfDayGMT)(Date.now()) - (0, dailyRevenue_js_1.getEndOfDayGMT)(1719519457000)) /
                    (24 * 60 * 60 * 1000) +
                    1,
            };
        }));
        // const coinsToFetchFromCoinGecko = coinsToFetch.filter(
        //   (o) => o.coinPair !== "STSUI/USD",
        // );
        // const historicalPrices = await fetchHistoricalPricesFromCoinGecko({
        //   coinsToFetch: coinsToFetchFromCoinGecko,
        //   coinGeckoApiKey: params.coinGeckoApiKey,
        // });
        const historicalPrices = await fetchHistoricalPricesFromCoinGecko({
            coinsToFetch: coinsToFetch,
            coinGeckoApiKey: params.coinGeckoApiKey,
        });
        const massagedHistoricalPrices = massageHistoricalPrices({
            historicalPrices,
        });
        // const stSuiToFetch = coinsToFetch.find((o) => o.coinPair === "STSUI/USD");
        // if (stSuiToFetch) {
        //   // TODO --> optimisation: fetch sui price if it is not available, else get from DB or/and massagedHistoricalPrices
        //   const suiHistoricalPrices = massageHistoricalPrices({
        //     historicalPrices: await fetchHistoricalPricesFromCoinGecko({
        //       coinsToFetch: [{ coinPair: "SUI/USD", days: stSuiToFetch.days }],
        //       coinGeckoApiKey: params.coinGeckoApiKey,
        //     }),
        //   });
        //   const stSuiHistoricalPrices = await getHistoricalStSuiPrice({
        //     suiHistoricalPrice: suiHistoricalPrices["SUI/USD"],
        //     daysToFetch: stSuiToFetch.days,
        //   });
        //   if (stSuiHistoricalPrices["STSUI/USD"])
        //     massagedHistoricalPrices["STSUI/USD"] = stSuiHistoricalPrices[
        //       "STSUI/USD"
        //     ].sort((a, b) => a[0] - b[0]);
        // }
        await putPricesDataToHistoricalPricesDynamoDb({
            tableName,
            historicalPrices: massagedHistoricalPrices,
        });
    }
    catch (err) {
        const errorObj = err instanceof Error ? err : new Error(String(err));
        (0, logger_js_1.logError)(`Failed to update historical prices in DynamoDB`, {
            component: "prices",
            operation: "updateHistoricalPricesDynamoDb",
            context: {
                error: errorObj,
            },
        });
        throw errorObj;
    }
}
function massageHistoricalPrices(params) {
    const historicalPrices = params.historicalPrices;
    const massagedHistoricalPrices = {};
    for (const coinPair in historicalPrices) {
        historicalPrices[coinPair].pop();
        if (!historicalPrices[coinPair]) {
            (0, logger_js_1.logError)("unexpected historicalPrices, atleast one expected", {
                component: "prices",
                operation: "massageHistoricalPrices",
                context: {
                    coinPair,
                    historicalPrices,
                },
            });
            throw new Error("unexpected historicalPrices, atleast one expected");
        }
        const formattedTimePricePairs = historicalPrices[coinPair].map(([time, price]) => {
            return [time - 1, price];
        });
        massagedHistoricalPrices[coinPair] = formattedTimePricePairs;
    }
    return massagedHistoricalPrices;
}
// ------------ redundant --------------
// function isContinuousDaily(times: number[]): boolean {
//   if (times.length < 2) return true;
//   const sorted = [...times].sort((a, b) => a - b);
//   const DAY_MS = 24 * 60 * 60 * 1000;
//   for (let i = 1; i < sorted.length; i++) {
//     if (sorted[i] - sorted[i - 1] !== DAY_MS) {
//       return false;
//     }
//   }
//   return true;
// }
// export async function repairMissingCoinGeckoPrices(params: {
//   missingPrices: { [coinPair: string]: number[] };
//   coinGeckoApiKey: string;
// }): Promise<HistoricalPrices> {
//   const { missingPrices, coinGeckoApiKey } = params;
//   const repairedPrices: HistoricalPrices = {};
//   const coinsToFetch = Object.entries(missingPrices).map(
//     ([coinPair, times]) => ({
//       coinPair,
//       days: Math.ceil(
//         (Date.now() - Math.min(...times)) / (24 * 60 * 60 * 1000),
//       ),
//     }),
//   );
//   const fetchedPrices = await fetchHistoricalPricesFromCoinGecko({
//     coinsToFetch,
//     coinGeckoApiKey,
//   });
//   for (const [coinPair, times] of Object.entries(missingPrices)) {
//     const historicalPrice = fetchedPrices[coinPair];
//     if (!historicalPrice) {
//       console.log(
//         `Coin: ${coinPair} - No data fetched from CoinGecko for the missing times.`,
//       );
//     }
//     const filteredPrices = historicalPrice
//       ? historicalPrice.filter(([time]) => times.includes(time))
//       : [];
//     if (filteredPrices.length > 0) {
//       repairedPrices[coinPair] = filteredPrices;
//     }
//     const leftoverTimes = times.filter(
//       (t) => !filteredPrices.some(([foundTime]) => foundTime === t),
//     );
//     if (leftoverTimes.length > 0) {
//       const leftoverMin = Math.min(...leftoverTimes);
//       const leftoverMax = Math.max(...leftoverTimes);
//       const leftoverCount = leftoverTimes.length;
//       const leftoverRange = `[${new Date(leftoverMin).toISOString()} - ${new Date(
//         leftoverMax,
//       ).toISOString()}]`;
//       console.log(
//         `Coin: ${coinPair} is missing ${leftoverCount} timestamp(s) in the range ${leftoverRange}.`,
//       );
//       const expectedDayCount =
//         Math.floor((leftoverMax - leftoverMin) / (24 * 60 * 60 * 1000)) + 1;
//       const isContinuous = isContinuousDaily(leftoverTimes);
//       if (leftoverTimes.length === expectedDayCount && isContinuous) {
//         console.log(
//           `Coin: ${coinPair} - The missing range is fully continuous daily. It is probable that the coin did not exist during this period.`,
//         );
//       } else {
//         console.error(
//           `Coin: ${coinPair} - The missing range is not fully continuous daily. This is unexpected and may indicate an error.`,
//         );
//       }
//     }
//   }
//   return repairedPrices;
// }
// export async function repairMissingStSuiPrices(params: {
//   missingTimes: number[];
//   suiHistoricalPrice: [number, number][];
//   daysToFetch: number;
// }): Promise<HistoricalPrices> {
//   const { missingTimes, suiHistoricalPrice, daysToFetch } = params;
//   const fullStSuiPriceData = await getHistoricalStSuiPrice({
//     suiHistoricalPrice,
//     daysToFetch,
//   });
//   const existingPrices =
//     fullStSuiPriceData["STSUI/USD"]?.slice().sort((a, b) => a[0] - b[0]) || [];
//   const existingPriceMap = new Map<number, number>(existingPrices);
//   const sortedExistingTimes = existingPrices.map(([time]) => time);
//   const repairedStSuiPrices: HistoricalPrices = { "STSUI/USD": [] };
//   const sortedMissingTimes = missingTimes.slice().sort((a, b) => a - b);
//   for (const missingTime of sortedMissingTimes) {
//     if (existingPriceMap.has(missingTime)) {
//       repairedStSuiPrices["STSUI/USD"].push([
//         missingTime,
//         existingPriceMap.get(missingTime)!,
//       ]);
//       continue;
//     }
//     const previousTime = [...sortedExistingTimes]
//       .reverse()
//       .find((time) => time < missingTime);
//     const previousPrice =
//       previousTime !== undefined
//         ? existingPriceMap.get(previousTime)
//         : undefined;
//     if (previousPrice !== undefined) {
//       repairedStSuiPrices["STSUI/USD"].push([missingTime, previousPrice]);
//       continue;
//     }
//     // If no previous price is found and the missing time is after STSUI_FIRST_TIME, calculate the price
//     if (missingTime > 1733875199999) {
//       const suiPrice = suiHistoricalPrice
//         .find(([time]) => time === missingTime)?.[1]
//         .toString();
//       if (!suiPrice) {
//         console.warn(`SUI price not found for timestamp ${missingTime}`);
//         continue;
//       }
//       const historicalExchangeRate = await getHistoricalExchangeRate({
//         startTime: getStartOfDayGMT(missingTime),
//         endTime: missingTime,
//       });
//       const stSuiPrice = getStSuiPrice({
//         suiPrice,
//         stSuiExchangeRate: historicalExchangeRate[missingTime],
//       });
//       if (stSuiPrice) {
//         repairedStSuiPrices["STSUI/USD"].push([
//           missingTime,
//           Number(stSuiPrice),
//         ]);
//       } else {
//         console.error(
//           `No data or fallback available for timestamp ${missingTime}`,
//         );
//       }
//     }
//   }
//   if (repairedStSuiPrices["STSUI/USD"].length > 0) {
//     repairedStSuiPrices["STSUI/USD"].sort((a, b) => a[0] - b[0]);
//   }
//   return repairedStSuiPrices;
// }
// export async function checkHistoricalPrices(
//   params: {
//     historicalPrices: HistoricalPrices;
//     maxTime: number;
//     minTime: number;
//     coinGeckoApiKey?: string;
//   },
//   repair: boolean,
// ): Promise<HistoricalPrices> {
//   const { historicalPrices, minTime, maxTime } = params;
//   const missingPrices: { [coinPair: string]: number[] } = {};
//   const missingStSuiTimes: number[] = [];
//   const coinGeckoApiKey = params.coinGeckoApiKey
//     ? params.coinGeckoApiKey
//     : process.env.COIN_GECKO_API_KEY;
//   if (!coinGeckoApiKey) {
//     throw new Error("CoinGecko Api key not found");
//   }
//   for (const [coinPair, prices] of Object.entries(historicalPrices)) {
//     const availableDays = new Set(prices.map(([time]) => time));
//     let currentDay = getEndOfDayGMT(minTime);
//     const lastDay = getEndOfDayGMT(maxTime);
//     if (coinPair === "STSUI/USD") {
//       while (currentDay <= lastDay) {
//         // first available STSUI price
//         if (!availableDays.has(currentDay) && currentDay >= 1733875200000) {
//           missingStSuiTimes.push(currentDay);
//         }
//         currentDay += 24 * 60 * 60 * 1000;
//       }
//     } else {
//       while (currentDay <= lastDay) {
//         if (!availableDays.has(currentDay)) {
//           if (!missingPrices[coinPair]) {
//             missingPrices[coinPair] = [];
//           }
//           missingPrices[coinPair].push(currentDay);
//         }
//         currentDay += 24 * 60 * 60 * 1000;
//       }
//     }
//   }
//   const updatedHistoricalPrices: HistoricalPrices = {};
//   if (Object.keys(missingPrices).length > 0) {
//     const repairedPrices = await repairMissingCoinGeckoPrices({
//       missingPrices,
//       coinGeckoApiKey,
//     });
//     for (const [coinPair, prices] of Object.entries(repairedPrices)) {
//       if (!historicalPrices[coinPair]) {
//         historicalPrices[coinPair] = [];
//       }
//       historicalPrices[coinPair].push(...prices);
//       historicalPrices[coinPair].sort((a, b) => a[0] - b[0]);
//       if (!updatedHistoricalPrices[coinPair]) {
//         updatedHistoricalPrices[coinPair] = [];
//       }
//       updatedHistoricalPrices[coinPair].push(...prices);
//     }
//   }
//   if (missingStSuiTimes.length > 0) {
//     const dynamicDaysToFetch = Math.ceil(
//       (Date.now() - minTime) / (24 * 60 * 60 * 1000),
//     );
//     const suiHistoricalPrice = massageHistoricalPrices({
//       historicalPrices: await fetchHistoricalPricesFromCoinGecko({
//         coinsToFetch: [
//           {
//             coinPair: "SUI/USD",
//             days: dynamicDaysToFetch,
//           },
//         ],
//         coinGeckoApiKey,
//       }),
//     })["SUI/USD"];
//     if (suiHistoricalPrice.length > 0) {
//       const repairedStSuiPrices = await repairMissingStSuiPrices({
//         missingTimes: missingStSuiTimes,
//         suiHistoricalPrice,
//         daysToFetch: dynamicDaysToFetch,
//       });
//       if (
//         repairedStSuiPrices["STSUI/USD"] &&
//         repairedStSuiPrices["STSUI/USD"].length > 0
//       ) {
//         historicalPrices["STSUI/USD"].push(...repairedStSuiPrices["STSUI/USD"]);
//         historicalPrices["STSUI/USD"].sort((a, b) => a[0] - b[0]);
//         if (!updatedHistoricalPrices["STSUI/USD"]) {
//           updatedHistoricalPrices["STSUI/USD"] = [];
//         }
//         updatedHistoricalPrices["STSUI/USD"].push(
//           ...repairedStSuiPrices["STSUI/USD"],
//         );
//       }
//     }
//   }
//   if (repair) {
//     if (Object.keys(updatedHistoricalPrices).length > 0) {
//       await putPricesDataToHistoricalPricesDynamoDb({
//         historicalPrices: updatedHistoricalPrices,
//       });
//       return updatedHistoricalPrices;
//     }
//     return historicalPrices;
//   }
//   return historicalPrices;
// }
// ------------ redundant --------------
//stSui
// needs massaged sui historical price
async function getHistoricalStSuiPrice(params) {
    const historicalExchangeRate = await getHistoricalExchangeRate({
        startTime: (0, TVL_js_1.getStartOfDayGMT)(Date.now() - params.daysToFetch * 24 * 60 * 60 * 1000),
        endTime: (0, dailyRevenue_js_1.getEndOfDayGMT)(Date.now() - 24 * 60 * 60 * 1000),
    });
    // TODO: add check if sui price not massaged then handle the error
    const historicalStSuiPrice = {};
    for (const timestamp in historicalExchangeRate) {
        const suiPrice = params.suiHistoricalPrice
            .find(([time]) => {
            return Number(time) === Number(timestamp);
        })?.[1]
            .toString();
        if (!suiPrice)
            throw new Error(`sui price not found for timestamp ${timestamp}`);
        const stSuiPrice = getStSuiPrice({
            stSuiExchangeRate: historicalExchangeRate[timestamp],
            suiPrice: suiPrice,
        });
        if (!historicalStSuiPrice["STSUI/USD"]) {
            historicalStSuiPrice["STSUI/USD"] = [];
        }
        historicalStSuiPrice["STSUI/USD"].push([
            Number(timestamp),
            Number(stSuiPrice),
        ]);
    }
    if (historicalStSuiPrice &&
        historicalStSuiPrice["STSUI/USD"] &&
        historicalStSuiPrice["STSUI/USD"].length > 1) {
        historicalStSuiPrice["STSUI/USD"] = historicalStSuiPrice["STSUI/USD"].sort((a, b) => a[0] - b[0]);
    }
    return historicalStSuiPrice;
}
// get historical stsui exchange rate
async function getHistoricalExchangeRate(params) {
    const events = await stsui_sdk_1.Events.getEpochChangeEvents({
        startTime: params.startTime,
        endTime: params.endTime,
        typeName: (0, stsui_sdk_1.getConf)().STSUI_COIN_TYPE,
    });
    const historicalExchangeRate = {};
    for (const event of events) {
        const suiSupply = new decimal_js_1.Decimal(event.event.new_sui_supply).minus(new decimal_js_1.Decimal(event.event.spread_fee));
        const stSuiSupply = new decimal_js_1.Decimal(event.event.lst_supply);
        const exchangeRate = new decimal_js_1.Decimal(suiSupply).div(stSuiSupply);
        historicalExchangeRate[(0, dailyRevenue_js_1.getEndOfDayGMT)(Number(event.timestamp))] =
            exchangeRate.toString();
    }
    return historicalExchangeRate;
}
function getStSuiPrice(params) {
    const suiPrice = new decimal_js_1.Decimal(params.suiPrice);
    const stSuiExchangeRate = new decimal_js_1.Decimal(params.stSuiExchangeRate);
    return suiPrice.mul(stSuiExchangeRate).toString();
}
//# sourceMappingURL=prices.js.map